/*eslint-disable */
define(function (require) {
    var $ = require('jquery');
    var _ = require('underscore');
    var numberFormatter = require('common/formatter/number-formatter');
    var pageConfig = require('common/page-config');

    var currencyCodeSymbols = {
        // Once packed as mobile app assets, UTF8 encoding is not being respected
        // when the javascript is loaded in the browser (despite the file being
        // encoded correctly).
        // So to play it safe, the symbols are escaped in the string literals.
        GBP: '\u00a3',
        USD: '$',
        EUR: '\u20ac',
        CHF: 'CHF',
        DKK: 'kr.',
    };

    function returnCurrencySymbol (code) {
        return currencyCodeSymbols[code];
    }

    function range(minPrice, maxPrice, hideZeroValueDecimalPlaces) {
        if (_.isEqual(minPrice, maxPrice)) {
            return format(minPrice, hideZeroValueDecimalPlaces);
        } else {
            return format(minPrice, hideZeroValueDecimalPlaces) + ' - ' + format(maxPrice, hideZeroValueDecimalPlaces);
        }
    }

    function fromMin(minPrice, maxPrice, hideZeroValueDecimalPlaces) {
        return ( _.isEqual(minPrice, maxPrice) ? '' : '<span class="from">' + pageConfig.fromPricePrefix + '</span>' ) +
            '<span class="price">' + format(minPrice, hideZeroValueDecimalPlaces) + '</span>';
    }

    function isFromPrice(minSalePrice, maxSalePrice) {
        return minSalePrice != null && maxSalePrice != null && maxSalePrice.amount != minSalePrice.amount;
    }

    function getDiscountPercentage(maxDiscountPercentage, fromPrice, isMaxDuration) {
        if (maxDiscountPercentage != null && fromPrice && !isMaxDuration) {
            var roundedDiscount = Math.round(maxDiscountPercentage);
            if (roundedDiscount > 0) {
                return '<span class="discount">' + pageConfig.pricingDiscountLabel + ' ' + roundedDiscount + '%</span>';
            }
        }

        return "";
    }

    function getStrikeThrough(minSalePrice, maxSalePrice, maxFullPrice, hideZeroValueDecimalPlaces, isMaxDuration) {
        if (maxFullPrice != null && minSalePrice != null
            && maxFullPrice.amount != minSalePrice.amount
            && !isFromPrice(minSalePrice, maxSalePrice) && !isMaxDuration) {
            return '<span class="full">' + format(maxFullPrice, hideZeroValueDecimalPlaces) + '</span> ';
        }

        return "";
    }

    function getMainPrice(minSalePrice, maxSalePrice, hideZeroValueDecimalPlaces) {
        if (minSalePrice != null) {
            var actualPrice = '<span class="price">' + format(minSalePrice, hideZeroValueDecimalPlaces) + '</span>';
            var prefix = '';
            if (isFromPrice(minSalePrice, maxSalePrice)) {
                prefix = '<span class="from">' + pageConfig.fromPricePrefix + '</span>';
            }
            return prefix + actualPrice;
        }

        return "";
    }

    function priceWithPromotion(minSalePrice, maxSalePrice, maxFullPrice, maxDiscountPercentage, hideZeroValueDecimalPlaces, isMaxDuration) {
        var fromPrice = isFromPrice(minSalePrice, maxSalePrice);

        return getDiscountPercentage(maxDiscountPercentage, fromPrice, isMaxDuration) +
               getStrikeThrough(minSalePrice, maxSalePrice, maxFullPrice, hideZeroValueDecimalPlaces, isMaxDuration) +
               getMainPrice(minSalePrice, maxSalePrice, hideZeroValueDecimalPlaces);
    }

    function fromMinRaw(minPrice, maxPrice, hideZeroValueDecimalPlaces) {
        return {
            price  : format(minPrice, hideZeroValueDecimalPlaces),
            isFrom : !(_.isEqual(minPrice, maxPrice))
        };
    }

    function formatNoDecimal(price) {
        var symbol = currencyCodeSymbols[price.currencyCode];
        var amount = Math.ceil(price.amount);

        return symbol + amount;
    }

    var currencyFormatConfig = {
            currencyFormat : [],
            currencyCode : null,
            currencySymbolPosition : 'START',
            hasSymbol : false,
            configSet: false,
            SetConfig : function setConfig(price){
                            if(pageConfig.hasOwnProperty('locale')){
                                currencyFormatConfig.currencyFormat = pageConfig.locale.currencyFormat.split('_');
                                currencyFormatConfig.currencyCode = price.currencyCode || pageConfig.locale.currencyCode;
                            } else {
                                currencyFormatConfig.currencyCode = price.currencyCode;
                            }
                            if (currencyFormatConfig.currencyFormat[0] === 'WHITESPACE' ||
                                currencyFormatConfig.currencyFormat[1] === 'END' ){
                                currencyFormatConfig.hasWhiteSpace = true;
                                currencyFormatConfig.currencySymbolPosition = 'END';
                            }
                            if (currencyFormatConfig.currencyFormat[1] === 'WHITESPACE'){
                                currencyFormatConfig.hasWhiteSpace = true;
                                currencyFormatConfig.currencySymbolPosition = 'START';
                            }
                            currencyFormatConfig.hasSymbol = (currencyFormatConfig.currencyFormat[0] === 'SYMBOL' || currencyFormatConfig.currencyFormat[1] === 'SYMBOL');

                            currencyFormatConfig.switchesSet = true;
                        }
        };

    function format(price, hideZeroValueDecimalPlaces, zeroAsText) {
        currencyFormatConfig.SetConfig(price);
        if (!price) {
            return null;
        }
        if (zeroAsText !== false) {
            zeroAsText = true;
        }
        var amount = price.amount;
        var minus = '';
        var formattedPrice;
        var showDecimals = true;
        var symbol = currencyFormatConfig.hasSymbol ? currencyCodeSymbols[currencyFormatConfig.currencyCode] : currencyFormatConfig.currencyCode;
        if (amount === 0 && zeroAsText) {
            formattedPrice = pageConfig.zeroPriceText || 'zeroPriceText missing from pageConfig';
        } else {
            if (amount < 0) {
                amount = amount * -1;
                minus = '-';
            }

            amount = parseFloat(Math.round(amount * 100) / 100).toFixed(2);

            if (amount % 1 === 0 && hideZeroValueDecimalPlaces) {
                amount = Math.ceil(amount);
                showDecimals = false;
            }

            // format amount number
            amount = numberFormatter.format(amount, showDecimals);
            if (currencyFormatConfig.currencySymbolPosition == 'END'){
                formattedPrice = minus + amount;
                formattedPrice += currencyFormatConfig.hasWhiteSpace ? ' ' : '';
                formattedPrice += symbol;
            } else {
                formattedPrice = minus + symbol;
                formattedPrice += currencyFormatConfig.hasWhiteSpace ? ' ' : '';
                formattedPrice += amount;
            }
        }
        return formattedPrice;
    }


    function formatDisplay(price, hideZeroValueDecimalPlaces) {
        var span = '<span></span>';
        var currencyFormat = pageConfig.locale.currencyFormat.split('_');
        var currencyCode = price.currencyCode;

        if (pageConfig.hasOwnProperty('locale')) {
            currencyFormat = pageConfig.locale.currencyFormat.split('_');
            currencyCode = currencyCode || pageConfig.locale.currencyCode;
        }

        var symbol = currencyFormat[0] === 'SYMBOL' ? currencyCodeSymbols[currencyCode] : currencyCode;
        var integer;
        var decimal = price.amount % 1;
        var includeDecimal;

        if (decimal === 0 && hideZeroValueDecimalPlaces) {
            integer = Math.ceil(price.amount);
            includeDecimal = false;
        } else {
            integer = Math.floor(price.amount);
            includeDecimal = true;
        }

        var $currency = $(span).addClass('price-currency').text(symbol);
        var $integer = $(span).addClass('price-integer').text(integer);
        var $decimalPoint = $(span).addClass('price-decimal-point').text(pageConfig.locale.decimalSeparator);
        var $decimal = $(span).addClass('price-decimal').text(decimal.toFixed(2).substr(2));

        var $price = $('<span></span>');

        if (currencyFormat[1] === 'START') {
            $price.append($currency);
        }

        $price.append($integer);

        if (includeDecimal) {
            $price.append($decimalPoint, $decimal);
        }

        if (currencyFormat[1] === 'END') {
            $price.append($currency);
        }

        return $price;
    }

    return {
        returnCurrencySymbol: returnCurrencySymbol,
        format: format,
        formatNoDecimal: formatNoDecimal,
        formatDisplay: formatDisplay,
        range: range,
        fromMin: fromMin,
        fromMinRaw: fromMinRaw,
        priceWithPromotion: priceWithPromotion
    };
});
